var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import MediaService from '../services/MediaService';
import { useStore } from '../store';
import { MIME_TYPES } from '../util/const_helper';
export function useFile() {
    const store = useStore();
    function uploadFile(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { parentId, file, trackingProgressId } = payload;
            // get signed url
            const params = {
                name: file.name,
                contentType: file.type,
                parentId: parentId || '',
                altType: store.altType,
                altId: store.altId,
                size: file.size,
            };
            const { data } = yield MediaService.createUploadSignedUrl(params);
            const signedUrl = data.url;
            return new Promise(function (resolve, reject) {
                const formData = new FormData();
                formData.append('file', file);
                const xhr = new XMLHttpRequest();
                xhr.open('PUT', signedUrl, true);
                xhr.onload = () => {
                    const status = xhr.status;
                    if (status === 200) {
                        resolve({ trackingProgressId, aknId: data.aknId });
                    }
                    else {
                        reject('Something went wrong');
                    }
                };
                xhr.onerror = () => {
                    reject('Something went wrong');
                };
                xhr.setRequestHeader('Content-Type', file.type);
                xhr.send(file);
            });
        });
    }
    function validFileSize(file) {
        let limit;
        if (MIME_TYPES['video'].includes(file.type)) {
            limit = store.maxUploadSize.video;
        }
        else if (MIME_TYPES['image'].includes(file.type)) {
            limit = store.maxUploadSize.image;
        }
        else if (MIME_TYPES['audio'].includes(file.type)) {
            limit = store.maxUploadSize.audio;
        }
        else if (MIME_TYPES['documents']['pdf'].includes(file.type) ||
            MIME_TYPES['documents']['doc'].includes(file.type) ||
            MIME_TYPES['documents']['excel'].includes(file.type) ||
            MIME_TYPES['documents']['ppt'].includes(file.type) ||
            MIME_TYPES['documents']['text'].includes(file.type)) {
            limit = store.maxUploadSize.document;
        }
        else {
            limit = 100000000;
        }
        return file.size <= limit;
    }
    function verifyFileUpload(aknId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield MediaService.verifyFileUpload({
                    altId: store.altId,
                    altType: store.altType,
                    id: aknId,
                });
                return data;
            }
            catch (error) {
                console.info(error);
                return false;
            }
        });
    }
    function allowedFileType() {
        const ext = store.allowedExtensions;
        const tempExt = [];
        for (let index = 0; index < ext.length; index++) {
            const extension = ext[index];
            const extensions = MIME_TYPES[extension];
            if (Array.isArray(extensions)) {
                tempExt.push(...extensions);
            }
            else {
                for (const key in extensions) {
                    tempExt.push(...extensions[key]);
                }
            }
        }
        return tempExt;
    }
    function validFileType(file) {
        const allowedTypes = allowedFileType();
        return allowedTypes.indexOf(file.type) > -1;
    }
    function validateFileUpload(file) {
        if (!validFileSize(file)) {
            throw new Error('File size exceed the recommended limit');
        }
        if (!validFileType(file)) {
            throw new Error('File type not allowed');
        }
        return true;
    }
    return {
        uploadFile,
        allowedFileType,
        validateFileUpload,
        verifyFileUpload,
    };
}
